module.exports = __webpack_public_path__ + "linea-software-10.6cfc5077a8ac9e581ef5.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/linea/software/fonts/linea-software-10.svg
// module id = ../../../../../src/assets/fonts/linea/software/fonts/linea-software-10.svg
// module chunks = styles